class ModuleStore {
    constructor(rootStore) {
        this.rootStore = rootStore;
    }
}

export default ModuleStore;
